import { createContext, useContext, useEffect, useState } from 'react';

const DrawerContext = createContext({
  component: null,
  props: {},
  showDrawer: () => {},
  hideDrawer: () => {},
});

DrawerContext.displayName = 'DrawerContext';

const DrawerProvider = ({ children }) => {
  const [drawer, setDrawer] = useState({
    component: null,
    isOpen: false,
    isOpenForTheFirstTime: false,
    props: { direction: 'left' },
  });

  const showDrawer = (component, props = {}) =>
    setDrawer({ isOpen: true, isOpenForTheFirstTime: true, component, props });

  const hideDrawer = (props = {}) =>
    setDrawer({
      component: null,
      isOpen: false,
      isOpenForTheFirstTime: true,
      props,
    });

  useEffect(() => {
    if (drawer.isOpen) {
      document.body.classList.add('modal__body--open');
      return;
    }

    document.body.classList.remove('modal__body--open');
  }, [drawer.isOpen]);

  return (
    <DrawerContext.Provider value={{ hideDrawer, showDrawer, ...drawer }}>
      {children}
    </DrawerContext.Provider>
  );
};

const DrawerConsumer = DrawerContext.Consumer;
const useDrawer = () => useContext(DrawerContext);

export { DrawerConsumer, useDrawer };

export default DrawerProvider;
